export const CARD_HEIGHT_BIG = 363;
